import cryptoTradingJson from './content/cryptocurrency-trading.json';

export const cryptoTradingMock = {
    layoutType: 2,
    data: {
        name: 'cryptocurrency-trading',
        areasList: [
            {
                id: 1,
                name: 'CryptoTradingPage',
                componentName: 'Comp:CryptoTradingPage',
                content: JSON.stringify(cryptoTradingJson)
            }
        ]
    }
};
